import axios from "axios";

export const PORTAL_API = `${process.env.REACT_APP_BACKEND_URL}/api/portal`;
const KEY = "portal_token";

export const getToken = () => localStorage.getItem(KEY) || "";
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

export const papi = async (method, path, data, extra = {}) => {
  try {
    const r = await axios({ method, url: `${PORTAL_API}${path}`, data, headers: { Authorization: `Bearer ${getToken()}` }, ...extra });
    return r.data;
  } catch (e) {
    if (e?.response?.status === 401 && path !== "/auth/login") {
      setToken("");
      window.dispatchEvent(new Event("portal-logout"));
    }
    throw e;
  }
};

export const errText = (e) => {
  const st = e?.response?.status;
  if (!e?.response || st === 502 || st === 503 || st === 504)  // slow line / timeout: the office may still have received it
    return "The connection is slow — your orders may still be arriving. Check My parcels in a minute; sending again will NOT make duplicates.";
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

/* One id per Send: pressing Send twice or retrying on a slow line never makes duplicate orders. */
export const newSid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const qtyNum = (q) => Number((String(q || "").replace(/,/g, "").match(/\d+(\.\d+)?/) || [0])[0]);

export const money = (v, cur = "INR") => `${cur === "INR" ? "₹" : "$"}${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
